



















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CustomSelect extends Vue {
  isOpen = false;
  @Prop({default: null}) selectedLabel!: string[] | null;

  get limitedLabels(): string[] {
    return (this.selectedLabel || []).slice(0,6);
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (this.isOpen && !this.$el.contains(target)) {
      this.isOpen = false;
    }
  }

  // Diese Methode wird von den Option-Komponenten aufgerufen.
  selectOption(): void {
    this.isOpen = false;
  }
}
